<!--
  ~ Copyright 2020 Google LLC.
  ~ SPDX-License-Identifier: Apache-2.0
  -->

<span>dark mode</span>
<label class="switch">
  <input id='toggle' type="checkbox" (click)="onToggle()" [checked]="getCheck()">
  <span class="slider round"></span>
</label>
